import { Component } from '@mycolorway/tao';
import { MDCChipSet } from '@material/chips';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-chip-set', {
  mixins: [eventListenerMixin],

  properties: {
    closeable: {
      type: Boolean,
      default: true,
    },
  },

  connected() {
    this.chipSetElement = this.querySelector('.mdc-chip-set');
    this.mdcChipSet = new MDCChipSet(this.chipSetElement);

    this.listenTo(this.chipSetElement, 'click', this.handleClick.bind(this));
    this.listenTo(this.mdcChipSet, 'MDCChip:removal', this.handleChipRemoval.bind(this));
  },

  disconnected() {
    this.stopListening();
    if (this.mdcChipSet) this.mdcChipSet.destroy();
  },

  addChip(data = {}) {
    const lastChild = this.chipSetElement.lastElementChild;
    const newChip = data instanceof HTMLElement ? data : this.renderChip(data);

    if (lastChild && !lastChild.classList.contains('mdc-chip')) {
      this.chipSetElement.insertBefore(newChip, lastChild);
    } else {
      this.chipSetElement.insertAdjacentElement('beforeend', newChip);
    }

    this.mdcChipSet.addChip(newChip);
    return newChip;
  },

  addChips(chipsData = []) {
    const chips = document.createDocumentFragment();

    chipsData.forEach((data) => {
      const chip = data instanceof HTMLElement ? data : this.renderChip(data);
      chips.appendChild(chip);
    });

    const lastChild = this.chipSetElement.lastElementChild;
    if (lastChild && !lastChild.classList.contains('mdc-chip')) {
      this.chipSetElement.insertBefore(chips, lastChild);
    } else {
      this.chipSetElement.insertAdjacentElement('beforeend', chips);
    }

    this.chipSetElement.querySelectorAll('.mdc-chip')
      .forEach(chip => this.mdcChipSet.addChip(chip));
  },

  removeChip(selector) {
    Array.prototype.forEach.call(
      this.chipSetElement.querySelectorAll(selector),
      chip => this.chipSetElement.removeChild(chip),
    );
  },

  removeAllChips() {
    Array.from(this.chipSetElement.querySelectorAll('.mdc-chip'))
      .forEach(chip => this.chipSetElement.removeChild(chip));
  },

  renderChip({
    text, avatar, icon, data = {},
  } = {}) {
    const chip = document.createElement('div');
    chip.classList.add('mdc-chip');

    if (avatar) {
      chip.insertAdjacentHTML('beforeend', `
        <div class="mdc-chip__icon--leading avatar"><img src="${avatar}" alt="${text}" /></div>
      `);
    } else if (icon) {
      chip.insertAdjacentHTML('beforeend', `
        <i class="mdc-chip__icon mdc-chip__icon--leading twr twr-${icon}"></i>
      `);
    }

    Object.keys(data).forEach((dataKey) => {
      chip.setAttribute(`data-${dataKey}`, data[dataKey]);
    });

    chip.insertAdjacentHTML('beforeend', `<span class="mdc-chip__text">${text}</span>`);

    if (this.closeable) {
      chip.insertAdjacentHTML('beforeend', `
        <i class="mdc-chip__icon mdc-chip__icon--trailing twr twr-times"></i>
      `);
    }

    return chip;
  },

  handleClick(event) {
    const chipElement = closest(event.target, '.mdc-chip');
    if (chipElement) {
      this.namespacedTrigger('click', { detail: chipElement, bubbles: true });
    }
  },

  handleChipRemoval(event) {
    const chipElement = event.detail.root;
    this.namespacedTrigger('removal', { detail: chipElement, bubbles: true });

    if (this.chipSetElement.contains(chipElement)) {
      this.chipSetElement.removeChild(chipElement);
    }
  },
});
